export const gambioApp = {
  id: 95,
  name: "gambio",
  label: "Gambio",
  showTestConnection: true,
  logo: process.env.BASE_URL + "media/shopLogos/gambio.svg",
  areaBlacklist: ["migration", "reporting"],
  additional_params: {
    requestHeaders: {
      Accept: "application/json"
    },
    requestMethod: "GET",
    endpoint: "/api.php/v2/orders?page=1&per_page=1",
    authType: "basic"
  },
  environmentVariables: {
    presetId: process.env?.VUE_APP_SCM_APP_GAMBIO_PRESET_ID,
    testWorkflows: {
      product: process.env?.VUE_APP_SCM_APP_TEST_PRODUCT_WORKFLOW_ID,
      salesOrder: process.env?.VUE_APP_SCM_APP_GAMBIO_TEST_ORDER_WORKFLOW_ID,
      stock: process.env?.VUE_APP_SCM_APP_TEST_STOCK_WORKFLOW_ID,
      prices: process.env?.VUE_APP_SCM_APP_TEST_PRICES_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_TRACKING_WORKFLOW_ID
    },
    testBatchWorkflows: {
      salesOrder:
        process.env?.VUE_APP_SCM_APP_GAMBIO_TEST_BATCH_ORDER_WORKFLOW_ID,
      tracking: process.env?.VUE_APP_SCM_APP_TEST_BATCH_TRACKING_WORKFLOW_ID
    },
    CFLDataSetId: process.env?.VUE_APP_SCM_APP_GAMBIO_REPORTING_CFL_DATASET_ID,
    syncBatchWorkflowId:
      process.env?.VUE_APP_SCM_APP_GAMBIO_REPORTING_SYNC_BATCH_WORKFLOW_ID
  }
};
